// *** This file enables 3rd party trackers without checking for any user-consent! ***
// Before including this partial in your organizations views, you should consult a
// lawyer to confirm whether this is compliant with regulations in your jurisdiction

window.Test = function (testInput) {
  if (typeof window.Settings.piwik.url === 'undefined') {
    // Google analytics tests
    var h = {};
    if (window.location.hash) {
      //console.log("in hash: " + window.location.hash);
      var params = (decodeURIComponent(window.location.hash).substr(1)).split("&");

      for (var i = 0; i < params.length; i++)
      {
        var a = params[i].split("=");
        // Add parameters to object
        h[a[0]] = a[1];
      }
    }

    var testElement = testInput.el;
    var testName = testInput.name;
    var testId = testInput.experimentId;
    var testCohorts = testInput.cohorts;
    var testVariantName = "";
    var testDetail = {};

    if(!h[testId] && testId){
      //Not an admin checking on a test so put into ga test
      //Load the Content Experiment JavaScript API client for the experiment
      jQuery.getScript("//www.google-analytics.com/cx/api.js?experiment="+testId)
        .done(function() {
          // Ask Google Analytics which variation to show the user.
          // zero indexed number of experiment
          var testVariant = cxApi.chooseVariation();

          //cycle through variants and show the one that google wants us to
          var index = 0;
          for (var k in testCohorts) {
            if(index == testVariant){
              testVariantName = k;
              testDetail = testCohorts[k];
            }
            index++;
          }

          //implement test variant

          if(testDetail.html){
            $(""+testElement+"").html(testDetail.html);
          }

          if(testDetail.image){
            $(""+testElement+"").attr('src', testDetail.image);
          }

          if(testDetail.callback){
            testDetail.callback();
          }
          // send a non-interaction event to make sure person is registered as entering the test
          //console.log("Pre event fire");
          ga('send', 'event', 'test', 'entered', {'nonInteraction': 1});
      })
      .fail(function() {
        // console.log("failed to load GA custom setup");
      });

    } else if (h[testId] && testId) {
      // is an admin checking on a test so show them that variant.
      //console.log('Looking for your test, please hold...');
      var testToShow = h[testId];
      var index = 0;
      for (var k in testCohorts) {
        //console.log(index);
        if(index == testToShow){
          testVariantName = k;
          testDetail = testCohorts[k];
        }
        index++;
      }

      //console.log("showing test v: "+testVariantName);

      //implement test variant

      if(testDetail.html){
        $(""+testElement+"").html(testDetail.html);
      }

      if(testDetail.image){
        $(""+testElement+"").attr('src', testDetail.image);
      }

      if(testDetail.callback){
        testDetail.callback();
      }

    }
  } else {
    // PIWIK TESTS
    var testElement = testInput.el;
    var testName = testInput.name;
    var testId = testInput.experimentId;
    var testCohorts = testInput.cohorts;
    var testVariantName = "";
    var testDetail = {};

    var chosenCohort = Object.keys(testCohorts)[Math.floor(Math.random()*Object.keys(testCohorts).length)];
    testDetail = testCohorts[chosenCohort];

    if(testDetail.callback){
      testDetail.callback();
    }
    setTimeout(function() {
      if (typeof Campaign !== 'undefined') {
        trackEvent('testing', testInput.experimentId+'-'+chosenCohort, Campaign.public_internal_name);
      } else {
        trackEvent('testing', testInput.experimentId+'-'+chosenCohort);
      }
    }, 10000);

    for (var i = 0; i < testInput.actions.length; i++) {
      $("#r"+testInput.actions[i]+" [data-js-event-action]").each(function() {
        var el = $(this);
        var old = el.attr('data-js-event-action');
        el.attr('data-js-event-action', old + '-' + testInput.experimentId+'-'+chosenCohort);
      });
    }
  }
}
